import { useState, useMemo } from 'react'
import { useContainerWidth } from '@fs/zion-ui'

import getAssetUrl from '../utils/getAssetUrl'

export default function useResponsiveImage(url?: string, imageSizes?: ImageSize[]): string {
  const [imageSizesUrls, setImageSizesUrls] = useState<string[]>(Array(4).fill(getAssetUrl(url)))
  const atWidth = useContainerWidth()

  useMemo(() => {
    if (imageSizes?.length === 4) {
      setImageSizesUrls(imageSizes.map((size) => getAssetUrl(size.url)))
    }
  }, [imageSizes])

  const [originalUrl, phoneUrl, tabletUrl, desktopUrl] = imageSizesUrls
  const imageUrl = atWidth({ default: phoneUrl, md: tabletUrl, lg: desktopUrl, xxl: originalUrl })

  return imageUrl
}
